<template>
    <v-flex class="mb-5">
        <v-toolbar-title> {{ 'Paket Tur Rezervasyon' }}</v-toolbar-title>
        <v-card v-for="hizmet in ekhizmetler" class="mt-4" style="padding-top: 18px;"">
            <v-flex>
              <span style=" padding-left: 18px;" class="title">{{ hizmet.Isim }}</span>
    </v-flex>
    <br />
    <v-data-table width="950px" :headers="kisiHizmetHeaders" ref="kisilerTable" expand :items="kisiler"
        item-key="tckimlikNo" :hide-default-footer="true">
        <template v-slot:items="props">
            <tr item>
                <td class="text-xs-left">{{ props.item.Ad }} {{ props.item.Soyad }}</td>
                <td class="text-xs-left">
                    <input style="margin-left: 18px;" type="radio" :name="`choice-${hizmet.Id}-${props.item.Sira}`"
                        :id="`choice-${hizmet.Id}-${props.item.Sira}`" value="Evet"
                        @change="handleSelection(hizmet, props.item, 'Evet')" />
                    <label style="margin-left: 5px;">Evet</label>
                    <input style="margin-left: 18px;" type="radio" :name="`choice-${hizmet.Id}-${props.item.Sira}`"
                        :id="`choice-${hizmet.Id}-${props.item.Sira}`" value="Hayır"
                        @change="handleSelection(hizmet, props.item, 'Hayır')" />
                    <label style="margin-left: 5px;">Hayır</label>
                </td>
            </tr>
        </template>
    </v-data-table>
    </v-card>
    </v-flex>
</template>
<script>
import helpers from "@/components/app/customcomp/helpers.js"
export default {
    data() {
        return {
            ekhizmetler: [],
            selectedEkHizmetler:[],
            kisiHizmetHeaders: [
        {
          text: "Ad Soyad",
          value: "adSoyad"
        },
        {
          text: "İşlem"
        }
      ],
        }
    },
    props: {
        eklenenEkHizmetler: {
            type: Array,
            required: true,
        },
        kisiler:{
            type:Array,
            required:true
        },
        altGrup:{
            type:Object,
            required:true
        },
        ekhizmetler:{
            type:Array,
            required:true
        }
    },
    methods: {
        handleSelection(hizmet, kisi, value) {
            if (value === "Evet") {
                var dogumyili = new Date(kisi.DogumTarihi);
                var yas = helpers.getYear() - dogumyili.getFullYear();
                this.selectedEkHizmetler.push({
                    hizmet: {
                        Id: hizmet.Id,
                        Aciklama: hizmet.Aciklama,
                        Isim: hizmet.adSoyad,
                        Fiyat: hizmet.Fiyatlar.find(x => x.ParaBirimi == this.altGrup.SatisFiyat.ParaBirimi).Fiyat,
                        ParaBirimi: this.altGrup.SatisFiyat.ParaBirimi
                    },
                    kisi: {
                        KisiTip: kisi.KisiTip,
                        Yas: yas,
                        ProfilId: kisi.ProfilId,
                        SicilId: kisi.SicilId,
                        TcKimlikNo: kisi.TcKimlikNo,
                        Sira: 0,
                        UyeNo: kisi.UyeNo,
                        LastName: kisi.Soyad,
                        FirstName: kisi.Ad,
                        AdSoyad: kisi.Ad + ' ' + kisi.Soyad,
                        Adres: kisi.Adres,
                        DogumTarihi: kisi.DogumTarihi,
                        Cinsiyet: kisi.Cinsiyet,
                        Telefon1: kisi.Telefon1,
                        Gsm: kisi.Gsm,
                        EMail: kisi.EMail,
                        Isim: kisi.Ad,
                        Soyisim: kisi.Soyad
                    },
                });
            } else {
                this.selectedEkHizmetler = this.selectedEkHizmetler.filter(
                    (item) => item.hizmet.Id !== hizmet.Id || item.kisi.TcKimlikNo !== kisi.TcKimlikNo
                );
            }
            this.$emit("update-eklenen-ek-hizmetler", this.selectedEkHizmetler);


        },
    }
}
</script>
